import styled from 'styled-components';
import type { TextStyleValue } from '@elfsight/configurator-contracts';
import { Typography } from '@elfsight/widget-ui';
import { createReadableClass } from '@elfsight/widget-utils';

export interface HeadingProps {
  heading?: string;
  caption?: string;
  fieldHeadingColor?: string;
  fieldHeadingFontStyle?: TextStyleValue;
  fieldHintColor?: string;
  fieldHintFontStyle?: TextStyleValue;
}

export function Heading({
  heading,
  caption,
  fieldHeadingColor,
  fieldHeadingFontStyle,
  fieldHintColor,
  fieldHintFontStyle
}: HeadingProps) {
  return (
    <>
      {heading && (
        <HeadingControl
          textStyle={fieldHeadingFontStyle}
          color={fieldHeadingColor}
        >
          {heading}
        </HeadingControl>
      )}
      {caption && (
        <CaptionControl
          color={fieldHintColor}
          textStyle={{ fontSize: fieldHintFontStyle?.fontSize }}
          dangerouslySetInnerHTML={{ __html: caption }}
        />
      )}
    </>
  );
}

const HeadingControl = styled(Typography).attrs({
  className: createReadableClass({
    component: 'fields',
    element: 'heading-control'
  })
})``;

const CaptionControl = styled(Typography).attrs({
  className: createReadableClass({
    component: 'fields',
    element: 'caption-control'
  })
})`
  margin-top: 8px;
`;
